// Verbose [wopi] console tracing so the live Word Online walkthrough can be followed
// from the browser devtools. The prefix is greppable and every WOPI step logs through
// here; strip logging later by removing these calls.
export function wlog(message: string, ...details: unknown[]): void {
    console.log(`[wopi] ${message}`, ...details);
}
